import { Event } from '.';
var FoquzEvent = Event();
var HidePoppersEvent = FoquzEvent.get('poppers.hide');
export { HidePoppersEvent };
